<template>
  <div class="calculator-rating" :class="{ 'calculator-rating--fit': !isFrame }">
    <div class="calculator-rating__title">Оцените работу инструмента</div>
    <success-message v-if="isShowSuccess">
      {{ successText }}
    </success-message>
    <template v-else>
      <rating-grades :current-rating="currentRating" @updateGrade="updateGrade" />
      <rating-form
        :current-grade="currentRating"
        :is-loading="isLoading"
        @sendForm="sendForm"
        v-if="currentRating"
      />
    </template>
  </div>
</template>

<script>
import { gradesValues } from '@/utils/rating'
import RatingGrades from '@/components/smart/CalculatorRating/RatingGrades'
import { sendRating } from '@/api'
import SuccessMessage from '@/components/smart/CalculatorRating/Success-message'
import RatingForm from '@/components/smart/CalculatorRating/Rating-form'
import { frameMixin } from '@/mixins/frame-mixin'

export default {
  name: 'CalculatorRating',
  data: () => ({
    currentRating: null,
    isLoading: false,
    isShowSuccess: false
  }),
  methods: {
    updateGrade(grade) {
      this.currentRating = grade
    },
    sendForm(fields) {
      this.isLoading = true
      const formData = {
        form: 'CalculatorRating',
        fields: {
          ...fields,
          rating: this.currentRating,
          name: 'Онлайн карты районирования РФ'
        }
      }
      sendRating(formData)
        .then(() => {
          this.isLoading = false
          this.isShowSuccess = true
        })
        .catch(() => {
          this.isLoading = false
        })
    }
  },
  components: { RatingForm, SuccessMessage, RatingGrades },
  mixins: [frameMixin],
  computed: {
    successText() {
      return this.currentRating === gradesValues.idea
        ? 'Ваше предложение успешно отправлено, спасибо!'
        : 'Ваш комментарий успешно отправлен, спасибо!'
    }
  }
}
</script>

<style scoped lang="sass">
.calculator-rating
  grid-column-start: 2
  &--fit
    +media((margin: (0: 0 0 rem(32), 768: 0 0 rem(64))))
  &__title
    @extend %20
    font-weight: bold
    margin-bottom: rem(17)
</style>
